/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=72c962f4"
const script = {}

import "./App.vue?vue&type=style&index=0&id=72c962f4&lang=scss"

import exportComponent from "D:\\Workspace\\Micromes-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__